<div class="auth-card">
  <!-- Logo -->
  <a routerLink="/" class="auth-logo">
    <img src="assets/images/NBHA-Norway.png" alt="NBHA Norway" />
  </a>

  <!-- Header -->
  <div class="auth-header">
    <h1>Welcome back</h1>
    <p>Sign in to your account to continue</p>
  </div>

  <!-- Login Failed Alert -->
  <div *ngIf="isLoginFailed" class="alert alert-error">
    <i class="fa fa-exclamation-circle"></i>
    <div>
      <strong>Login failed</strong>
      <p class="mb-0">Invalid email or password. Please try again.</p>
    </div>
  </div>

  <!-- Login Form -->
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <!-- Email Field -->
    <div class="form-group">
      <label for="email" class="form-label">Email address</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        class="form-control"
        [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
        placeholder="you@example.com"
        required
      />
      <span *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="invalid-feedback">
        Please enter a valid email address
      </span>
    </div>

    <!-- Password Field -->
    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label for="password" class="form-label mb-0">Password</label>
        <a routerLink="/auth/forgot-password" class="auth-link-small" style="font-size: 13px; margin: 0;">Forgot password?</a>
      </div>
      <div class="password-toggle">
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          id="password"
          formControlName="password"
          class="form-control"
          [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          placeholder="Enter your password"
          required
        />
        <i
          [class]="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
          class="password-toggle-icon"
          (click)="togglePasswordVisibility('password')"
        ></i>
      </div>
      <span *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="invalid-feedback">
        Password is required
      </span>
    </div>

    <!-- Login Button -->
    <div class="form-group">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="loginForm.invalid"
      >
        Sign in
      </button>
    </div>
  </form>

  <!-- Divider -->
  <div class="auth-divider">
    <span>or</span>
  </div>

  <!-- Register Link -->
  <button
    type="button"
    class="btn btn-outline"
    routerLink="/auth/register-user"
  >
    Create new account
  </button>
</div>
